import { otherRouter, appRouter } from '@/router/router'

const app = {
  state: {
    menuList: [],
    routers: [
      otherRouter,
      ...appRouter
    ]
  },
  mutations: {
    //根据权限过滤菜单
    updateMenulist(state,aids) {
      let menuList = []
      //判断是否为管理员
      let admin = aids.find(item => item.authid == 1)
      if(admin) {
        state.menuList = appRouter
      } else {
        appRouter.forEach(router => {
          aids.forEach(aid => {
            if (router.meta.aid == aid.authid) {
              menuList.push(router)
            }
          })
        })
        state.menuList = menuList
      }
    }
  },
  actions: {
    async updateMenulist({ commit, rootState }) {
      commit('updateMenulist', rootState.user.user.auth)
    }
  }
};

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js